import React from 'react';
import {Redirect} from 'react-router-dom';
import {debugCNitoUrl} from '../../helpers';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            ...this.state,
            lastError: {title: error.toString(), stack: error.stack},
            lastInfo: JSON.stringify(errorInfo),
        });

        // eslint-disable-next-line
        console.error('Error: ', error);
        // eslint-disable-next-line
        console.warn('Error Info: ', errorInfo);
        // eslint-disable-next-line
        console.log(
            'Please, consider sending the info above to the development team.',
        );
    }

    render() {
        if (this.state.hasError) {
            this.setState({hasError: false});

            return <Redirect to={`/error${debugCNitoUrl()}`} />;
        }
        return this.props.children;
    }
}
